import { ALL_DEV_STATUS_MAP, ALL_SUBJECT_CONFIG_MAP, CT_FINDER_STUDY_STATUS_IDS } from '@patsnap/synapse_common_config'
import '@pharmsnap/shared/src/assets/icon-svg/fire.svg'
import { IAutoCompleteType, IListItem } from '@pharmsnap/shared/types'
import { DataTagKey, ICustomDateKey, ICustomNumberRangeKey } from './type'
export interface IHardData {
  display_name_en: string
  display_name_cn: string
  value: string
  icon?: string
}
const drugHighestPhaseIds = [
  '8666aad5477e4272b56b94ca1183781d',
  'b2ca28b01c34419db0365bad2f8dd09e',
  '3da2ce3ce8b0443fb0b2d335be3e591a',
  'e6438687ed214800bb98742ebbeb70a1',
  '91ac63db1def4da58e890aec574fe7f4',
  'e2c11c24a7ee4b4e81bbde9eb7127c6d',
  '192e487c57e24234b7562b7eafaeb8b7',
  '7b79728539354f189772a4eab9cc9fff',
  '9f31233bceb94d9796d3f3556f17ab13',
  'f835774c48404593b64ef05369eb8eba',
  '78c45f1d523646808032edcff807ca59',
  'efd6215835394b07b046125e3175d3fe',
  '055a60cf40bb4b4eb69c41b492c45a03',
  '4d95bf5fb0c340fbb38cda626c1c9c60',
  'a5183ad464de4fe9bb9a3583425ae4a2',
  'e6a367db1b4a4819bcc16b76dd26d5f3',
  'cf139751c1fd4a5892c786230e6f6b6a',
  'c9e8fce7eb6b4bbd9cc66dc356017aab',
]

const basicPhaseIds = [
  '8666aad5477e4272b56b94ca1183781d',
  'b2ca28b01c34419db0365bad2f8dd09e',
  '3da2ce3ce8b0443fb0b2d335be3e591a',
  'e6438687ed214800bb98742ebbeb70a1',
  '91ac63db1def4da58e890aec574fe7f4',
  'e2c11c24a7ee4b4e81bbde9eb7127c6d',
  '192e487c57e24234b7562b7eafaeb8b7',
  '7b79728539354f189772a4eab9cc9fff',
  '9f31233bceb94d9796d3f3556f17ab13',
  'f835774c48404593b64ef05369eb8eba',
  '78c45f1d523646808032edcff807ca59',
  'efd6215835394b07b046125e3175d3fe',
  '055a60cf40bb4b4eb69c41b492c45a03',
]
const pendingChildPhaseIds: string[] = basicPhaseIds.map((id) => `4d95bf5fb0c340fbb38cda626c1c9c60_${id}`)
const discontinuedChildPhaseIds = basicPhaseIds.map((id) => `a5183ad464de4fe9bb9a3583425ae4a2_${id}`)
const suspendedChildPhaseIds = basicPhaseIds.map((id) => `cf139751c1fd4a5892c786230e6f6b6a_${id}`)
function getDevStatusHardData(devStatusId: string): IHardData {
  const config = ALL_DEV_STATUS_MAP[devStatusId]
  return {
    display_name_en: config.display_name_en,
    display_name_cn: config.display_name_cn,
    value: devStatusId,
  }
}

function getDevStatusChildHardData(devStatusId: string): IListItem {
  const [, childId] = devStatusId.split('_')
  const config = ALL_DEV_STATUS_MAP[childId]
  return {
    display_name_en: config.display_name_en,
    display_name_cn: config.display_name_cn,
    id: devStatusId,
  }
}
export const pendingPhaseChildItems = pendingChildPhaseIds.map(getDevStatusChildHardData)
export const discontinuedPhaseChildItems = discontinuedChildPhaseIds.map(getDevStatusChildHardData)
export const suspendedPhaseChildItems = suspendedChildPhaseIds.map(getDevStatusChildHardData)
export const tagData: Partial<Record<DataTagKey, IHardData[]>> = {
  highestPhaseItems: [
    {
      display_name_en: 'All',
      value: 'All',
      display_name_cn: 'All',
    },
    ...drugHighestPhaseIds.map(getDevStatusHardData),
  ],
  phaseItems: [
    {
      display_name_en: 'All',
      value: 'All',
      display_name_cn: 'All',
    },
    ...drugHighestPhaseIds.map(getDevStatusHardData),
  ],
  dealCountryItems: [
    {
      display_name_en: 'Global',
      value: 'All',
      display_name_cn: '全球',
    },
    {
      display_name_en: 'United States',
      display_name_cn: '美国',
      value: 'US',
    },
    {
      display_name_en: 'Japan',
      display_name_cn: '日本',
      value: 'JP',
    },
    {
      display_name_en: 'China',
      display_name_cn: '中国',
      value: 'CN',
    },
    {
      display_name_en: 'Europe',
      display_name_cn: '欧洲',
      value: 'EU',
    },
    {
      display_name_en: 'Other',
      display_name_cn: '其他',
      value: 'Other',
    },
  ],
  dealDirectionItems: [
    {
      display_name_en: 'All',
      display_name_cn: 'All',
      value: 'All',
    },
    {
      display_name_en: 'Domestic only',
      display_name_cn: '仅境内',
      value: '5c672a2f1a0344ca83d08f710cbc5117',
    },
    {
      display_name_en: 'Overseas only',
      display_name_cn: '仅境外',
      value: '9226fe7163f848c98e40ff344f227646',
    },
    {
      display_name_en: 'From domestic to overseas',
      display_name_cn: '境内转境外',
      value: '4a71dbaf116c46a9a78ad6883c726001',
    },
    {
      display_name_en: 'From overseas to domestic',
      display_name_cn: '境外转境内',
      value: '5604e4327b4c4292af5b0ecb535ffb10',
    },
  ],
  dealPartnerPropertyItems: [
    {
      display_name_en: 'All',
      display_name_cn: 'All',
      value: 'All',
    },
    {
      display_name_en: 'United States',
      display_name_cn: '美国',
      value: 'US',
    },
    {
      display_name_en: 'China',
      display_name_cn: '中国',
      value: 'CN',
    },
    {
      display_name_en: 'Europe',
      display_name_cn: '欧洲',
      value: 'EUR',
    },
    {
      display_name_en: 'Japan',
      display_name_cn: '日本',
      value: 'JP',
    },
    {
      display_name_en: 'Outside United States',
      display_name_cn: '美国外',
      value: 'Outside US',
    },
    {
      display_name_en: 'Outside China',
      display_name_cn: '中国外',
      value: 'Outside CN',
    },
    {
      display_name_en: 'Outside Europe',
      display_name_cn: '欧洲外',
      value: 'Outside EUR',
    },
    {
      display_name_en: 'Outside Japan',
      display_name_cn: '日本外',
      value: 'Outside JP',
    },
  ],
  dealPrinciplePropertyItems: [
    {
      display_name_en: 'All',
      display_name_cn: 'All',
      value: 'All',
    },
    {
      display_name_en: 'United States',
      display_name_cn: '美国',
      value: 'US',
    },
    {
      display_name_en: 'China',
      display_name_cn: '中国',
      value: 'CN',
    },
    {
      display_name_en: 'Europe',
      display_name_cn: '欧洲',
      value: 'EUR',
    },
    {
      display_name_en: 'Japan',
      display_name_cn: '日本',
      value: 'JP',
    },
    {
      display_name_en: 'Outside United States',
      display_name_cn: '美国外',
      value: 'Outside US',
    },
    {
      display_name_en: 'Outside China',
      display_name_cn: '中国外',
      value: 'Outside CN',
    },
    {
      display_name_en: 'Outside Europe',
      display_name_cn: '欧洲外',
      value: 'Outside EUR',
    },
    {
      display_name_en: 'Outside Japan',
      display_name_cn: '日本外',
      value: 'Outside JP',
    },
  ],
  approvedCountryItems: [
    {
      display_name_en: 'Global',
      value: 'All',
      display_name_cn: '全球',
    },
    {
      display_name_en: 'United States',
      display_name_cn: '美国',
      value: '0dc5d896-7408-3c87-84c0-22e3d9b784be',
    },
    {
      display_name_en: 'European Union',
      display_name_cn: '欧盟',
      value: '9a18968a-f130-3a00-80b6-8b9e2eec4838',
    },
    {
      display_name_en: 'Japan',
      display_name_cn: '日本',
      value: '676de5ba-893a-36bb-8683-c93306aaf769',
    },
    {
      display_name_en: 'China',
      display_name_cn: '中国',
      value: '5a365096-b2a6-31cb-acdf-1de1f5ab3abe',
    },
    {
      display_name_en: 'Other',
      display_name_cn: '其他',
      value: 'Other',
    },
  ],
  organizationTypeItems: [
    {
      display_name_en: 'All',
      value: 'All',
      display_name_cn: 'All',
    },
    {
      display_name_en: 'Company',
      value: 'Company',
      display_name_cn: '公司',
    },
    {
      display_name_en: 'University/Institution',
      value: 'Education',
      display_name_cn: '大学/机构',
    },
    {
      display_name_en: 'Other',
      value: 'Other',
      display_name_cn: '其他',
    },
  ],
  // 修改 employeeNumberItems 时需要同时修改 function employNumScope
  employeeNumberItems: [
    {
      display_name_en: 'All',
      value: 'All',
      display_name_cn: 'All',
    },
    {
      display_name_en: '<10',
      value: '1',
      display_name_cn: '<10',
    },
    {
      display_name_en: '10~100',
      value: '2',
      display_name_cn: '10~100',
    },
    {
      display_name_en: '100~500',
      value: '3',
      display_name_cn: '100~500',
    },
    {
      display_name_en: '>500',
      value: '4',
      display_name_cn: '>500',
    },
  ],
  startupItems: [
    {
      display_name_en: 'Startups Only',
      value: 'true',
      display_name_cn: '初创公司',
    },
  ],
  sponsorCountryItems: [
    {
      display_name_en: 'Global',
      value: 'All',
      display_name_cn: '全球',
    },
    {
      display_name_en: 'Asia',
      display_name_cn: '亚洲',
      value: '154a6734-0e8c-34dd-9253-dc4ff6120197',
    },
    {
      display_name_en: 'North America',
      display_name_cn: '北美洲',
      value: '5ffec2d8-7ab5-3820-af8b-549af380913a',
    },
    {
      display_name_en: 'Europe',
      display_name_cn: '欧洲',
      value: '912d59cd-f1d3-3551-bae2-1f6f0062258f',
    },
    {
      display_name_en: 'Oceania',
      display_name_cn: '大洋洲',
      value: '2d883619-0888-367b-97ce-332cad2aa247',
    },
    {
      display_name_en: 'South America',
      display_name_cn: '南美洲',
      value: 'aab422ac-b3d2-334a-adec-a0e1495745c2',
    },
    {
      display_name_en: 'United States',
      display_name_cn: '美国',
      value: '0dc5d896-7408-3c87-84c0-22e3d9b784be',
    },
    {
      display_name_en: 'European Union',
      display_name_cn: '欧盟',
      value: '9a18968a-f130-3a00-80b6-8b9e2eec4838',
    },
    {
      display_name_en: 'Japan',
      display_name_cn: '日本',
      value: '676de5ba-893a-36bb-8683-c93306aaf769',
    },
    {
      display_name_en: 'China',
      display_name_cn: '中国',
      value: '5a365096-b2a6-31cb-acdf-1de1f5ab3abe',
    },
    {
      display_name_en: 'Other',
      display_name_cn: '其他',
      value: 'Other',
    },
  ],
  studyPhaseItems: [
    {
      display_name_en: 'All',
      value: 'All',
      display_name_cn: 'All',
    },
    ...CT_FINDER_STUDY_STATUS_IDS.map(getDevStatusHardData),
  ],
  estimatedEnrollmentItems: [
    {
      display_name_en: 'All',
      value: 'All',
      display_name_cn: 'All',
    },
    {
      display_name_en: '0~15',
      value: '-15',
      display_name_cn: '0~15',
    },
    {
      display_name_en: '15~60',
      value: '15-60',
      display_name_cn: '15~60',
    },
    {
      display_name_en: '60~300',
      value: '60-300',
      display_name_cn: '60~300',
    },
    {
      display_name_en: '300~500',
      value: '300-500',
      display_name_cn: '300~500',
    },
    {
      display_name_en: '>500',
      value: '500-',
      display_name_cn: '>500',
    },
  ],
  recruitmentStatusItems: [
    {
      display_name_en: 'All',
      value: 'All',
      display_name_cn: 'All',
    },
    {
      display_name_en: 'Not yet recruiting',
      value: 'Not yet recruiting',
      display_name_cn: 'Not yet recruiting',
    },
    {
      display_name_en: 'Recruiting',
      value: 'Recruiting',
      display_name_cn: 'Recruiting',
    },
    {
      display_name_en: 'Enrolling by invitation',
      value: 'Enrolling by invitation',
      display_name_cn: 'Enrolling by invitation',
    },
    {
      display_name_en: 'Active, not recruiting',
      value: 'Active, not recruiting',
      display_name_cn: 'Active, not recruiting',
    },
    {
      display_name_en: 'Suspended',
      value: 'Suspended',
      display_name_cn: 'Suspended',
    },
    {
      display_name_en: 'Terminated',
      value: 'Terminated',
      display_name_cn: 'Terminated',
    },
    {
      display_name_en: 'Completed',
      value: 'Completed',
      display_name_cn: 'Completed',
    },
    {
      display_name_en: 'Withdrawn',
      value: 'Withdrawn',
      display_name_cn: 'Withdrawn',
    },
    {
      display_name_en: 'Unknown status',
      value: 'Unknown status',
      display_name_cn: 'Unknown status',
    },
  ],
  simpleLegalStatusItems: [
    {
      display_name_en: 'All',
      value: 'All',
      display_name_cn: 'All',
    },
    {
      display_name_en: 'Inactive',
      value: '0',
      display_name_cn: '失效',
    },
    {
      display_name_en: 'Active',
      value: '1',
      display_name_cn: '有效',
    },
    {
      display_name_en: 'Pending',
      value: '2',
      display_name_cn: '审中',
    },
    {
      display_name_en: 'PCT designated stage',
      value: '221',
      display_name_cn: 'PCT指定期内',
    },
    {
      display_name_en: 'PCT designated stage expired',
      value: '220',
      display_name_cn: 'PCT指定期满',
    },
    {
      display_name_en: 'Undetermined',
      value: '999',
      display_name_cn: '未确认',
    },
  ],
  assigneeTypeItems: [
    {
      display_name_en: 'All',
      value: 'All',
      display_name_cn: 'All',
    },
    {
      display_name_en: 'Academy',
      value: 'ACADEMY',
      display_name_cn: '院校/研究所',
    },
    {
      display_name_en: 'Company',
      value: 'COMPANY',
      display_name_cn: '公司',
    },
    {
      display_name_en: 'Government',
      value: 'GOVERNMENT',
      display_name_cn: '政府',
    },
    {
      display_name_en: 'Person',
      value: 'PERSON',
      display_name_cn: '个人',
    },
    {
      display_name_en: 'Hospital',
      value: 'HOSPITAL',
      display_name_cn: '医院',
    },
    {
      display_name_en: 'Bank',
      value: 'BANK',
      display_name_cn: '银行',
    },
    {
      display_name_en: 'Other',
      value: 'OTHER',
      display_name_cn: '其他',
    },
  ],
  authorityCountryItems: [
    {
      display_name_en: 'All',
      value: 'All',
      display_name_cn: 'All',
    },
    {
      display_name_en: 'WIPO',
      display_name_cn: '世界知识产权组织',
      value: 'WO',
    },
    {
      display_name_en: 'United States',
      display_name_cn: '美国',
      value: 'US',
    },
    {
      display_name_en: 'EPO',
      display_name_cn: '欧洲专利局',
      value: 'EP',
    },
    {
      display_name_en: 'China',
      display_name_cn: '中国',
      value: 'CN',
    },
    {
      display_name_en: 'Japan',
      display_name_cn: '日本',
      value: 'JP',
    },
  ],
  therapyTypeItems: [
    {
      display_name_en: 'All',
      value: 'All',
      display_name_cn: 'All',
    },
    {
      display_name_cn: '一线',
      display_name_en: 'First line',
      value: '47ab7a553e2336a5b5ecde6d38d208e9',
    },
    {
      display_name_cn: '二线',
      display_name_en: 'Second line',
      value: 'c5e37a8173fb3e56b48d5d35b25e1a8b',
    },
    {
      display_name_cn: '三线',
      display_name_en: 'Third line',
      value: '62662f0b1d5b3fafabeb571a211e9a31',
    },
    {
      display_name_cn: '末线',
      display_name_en: 'Last line',
      value: '5d980a78d91b389fa653eab4c386dd57',
    },
    {
      display_name_cn: '辅助',
      display_name_en: 'Adjuvant',
      value: '41668084cc5234f0b29cb78894d0da62',
    },
    {
      display_name_cn: '新辅助',
      display_name_en: 'Neoadjuvant',
      value: '4e88ca62d0073b1ebb9700ab09cccd4d',
    },
    {
      display_name_cn: '维持',
      display_name_en: 'Maintenance',
      value: '10d0de28911c3f66863b9c8783f8148a',
    },
    {
      display_name_cn: '巩固',
      display_name_en: 'Consolidation',
      value: '4289ad5c614f3037a8810e869b56facd',
    },
    {
      display_name_cn: '追加',
      display_name_en: 'Add-on',
      value: 'b9aca50a3b39365a91ff3df678c21fe9',
    },
    {
      display_name_cn: '诱导',
      display_name_en: 'Induction',
      value: 'e8851e04a39e492e8958c64fe152c937',
    },
  ],
  therapyLineItems: [
    {
      display_name_en: 'All',
      value: 'All',
      display_name_cn: 'All',
    },
    {
      display_name_cn: '一线',
      display_name_en: 'First line',
      value: '47ab7a553e2336a5b5ecde6d38d208e9',
    },
    {
      display_name_cn: '二线',
      display_name_en: 'Second line',
      value: 'c5e37a8173fb3e56b48d5d35b25e1a8b',
    },
    {
      display_name_cn: '三线',
      display_name_en: 'Third line',
      value: '62662f0b1d5b3fafabeb571a211e9a31',
    },
    {
      display_name_cn: '末线',
      display_name_en: 'Last line',
      value: '5d980a78d91b389fa653eab4c386dd57',
    },
  ],
  meetingsItems: [
    {
      display_name_en: 'All',
      value: 'All',
      display_name_cn: 'All',
    },
    {
      display_name_cn: 'ASCO_GU 2024',
      display_name_en: 'ASCO_GU 2024',
      value: '70df011c77204f4ab659f7d1f82cd635_2024',
      icon: 'Fire',
    },
    {
      display_name_cn: 'ASCO_GI 2024',
      display_name_en: 'ASCO_GI 2024',
      value: '489225142e814a34b532512dbe802237_2024',
      icon: 'Fire',
    },
    {
      display_name_cn: 'ESMO_IO 2023',
      display_name_en: 'ESMO_IO 2023',
      value: 'efdc61b767694f82886f304cfe67825d_2023',
    },
    {
      display_name_cn: 'ESMO_ASIA 2023',
      display_name_en: 'ESMO_ASIA 2023',
      value: '97ed102c8d8640708dab5bdd239450e2_2023',
    },
    {
      display_name_en: 'ESMO 2023',
      display_name_cn: 'ESMO 2023',
      value: '67fd8cea1a49410ebdd966dda2755bf6_2023',
    },
    {
      display_name_cn: 'ASH 2023',
      display_name_en: 'ASH 2023',
      value: 'ca88304bde6747888c1de53f13aa16fb_2023',
    },
    {
      display_name_en: 'WCLC 2023',
      display_name_cn: 'WCLC 2023',
      value: '670b55e05b3f478e89048a7dcb38ed40_2023',
    },
    {
      display_name_cn: 'AACR 2023',
      display_name_en: 'AACR 2023',
      value: '8806d6ca778544e497f77fce5165778f_2023',
    },
  ],
  evaluationItems: [
    {
      display_name_en: 'All',
      value: 'All',
      display_name_cn: 'All',
    },
    {
      display_name_cn: '优效',
      display_name_en: 'Superiority',
      value: 'b768d49203dc39919ae9651a0a0155ab',
    },
    {
      display_name_cn: '积极',
      display_name_en: 'Positive',
      value: '3289297424e03eda9b788c083bbf3147',
    },
    {
      display_name_cn: '非劣',
      display_name_en: 'Non-inferiority',
      value: '501e92dcf2b133f6a9ebae6117b59236',
    },
    {
      display_name_cn: '相似',
      display_name_en: 'Similar',
      value: '0efa04d99d83316f84d2618cf4e013d4',
    },
    {
      display_name_cn: '非优',
      display_name_en: 'Non-superiority',
      value: '15f2cafc40333f8b92096bd4a26c0b26',
    },
    {
      display_name_cn: '不佳',
      display_name_en: 'Negative',
      value: 'ffb9356ff2b73a85875c92fa7ea03b8b',
    },
  ],
  agreementTypeItems: [
    {
      display_name_en: 'All',
      display_name_cn: 'All',
      value: 'All',
    },
    {
      display_name_en: 'Collaboration',
      display_name_cn: '合作',
      value: 'd6a713f676e84479918625e334e7ff9d',
    },
    {
      display_name_en: 'License',
      display_name_cn: '许可',
      value: 'c6bb6fa84d924b0cabd8f5dd2af17708',
    },
    {
      display_name_en: 'M&A',
      display_name_cn: '企业收购',
      value: '55a06cb457fb481d91a0a788eaad2c31',
    },
    {
      display_name_en: 'Asset Acquisition',
      display_name_cn: '项目收购',
      value: '21519be90c9840c8b002fd61194cacf4',
    },
    {
      display_name_en: 'Investment',
      display_name_cn: '投资',
      value: '72d4f04e831244e4806b927132e9fed0',
    },
    {
      display_name_en: 'Option',
      display_name_cn: '期权',
      value: '62e76fb48c6348e3b99fbfe6a1e3d919',
    },
  ],
  totalPaymentItems: [],
  amountDisclosureItems: [
    {
      display_name_en: 'All',
      display_name_cn: 'All',
      value: 'All',
    },
    {
      display_name_en: 'Yes',
      display_name_cn: '是',
      value: 'true',
    },
    {
      display_name_en: 'No',
      display_name_cn: '否',
      value: 'false',
    },
  ],
  dealExistItems: [
    {
      display_name_en: 'All',
      display_name_cn: 'All',
      value: 'All',
    },
    {
      display_name_en: 'Yes',
      display_name_cn: '是',
      value: 'true',
    },
    {
      display_name_en: 'No',
      display_name_cn: '否',
      value: 'false',
    },
  ],
  subjectItems: [
    {
      display_name_en: 'All',
      display_name_cn: 'All',
      value: 'All',
    },
    ...Object.values(ALL_SUBJECT_CONFIG_MAP).map((item) => ({
      display_name_en: item.name_en,
      display_name_cn: item.name_cn,
      value: item.dict_id,
    })),
  ],
  translationStageItems: [
    {
      display_name_en: 'All',
      display_name_cn: 'All',
      value: 'All',
    },
    {
      display_name_cn: 'T0',
      display_name_en: 'T0',
      value: 'a48788bd63a0384087cd7d089af6c610',
    },
    {
      display_name_cn: 'T1',
      display_name_en: 'T1',
      value: 'ce499dea30cf3e118f4fe85da0227e83',
    },
    {
      display_name_cn: 'T2',
      display_name_en: 'T2',
      value: '71d2c46af01f3eea94a0f541243e297b',
    },
    {
      display_name_cn: 'T3',
      display_name_en: 'T3',
      value: '54b02ae91c8c3b0aac069c84b9f78178',
    },
  ],
  journalItems: [
    {
      display_name_en: 'All',
      display_name_cn: 'All',
      value: 'All',
    },
    {
      display_name_cn: 'Nature',
      display_name_en: 'Nature',
      value: '368cf867-f484-430e-9530-44f5cccdd973',
    },
    {
      display_name_cn: 'Science',
      display_name_en: 'Science',
      value: '5f29f5ca-fe36-42e2-9a82-3f0a241d6a7e',
    },
    {
      display_name_cn: 'Cell',
      display_name_en: 'Cell',
      value: 'a8dad243-17a0-4a94-9cfe-546ae6164b04',
    },
    {
      display_name_cn: 'Lancet',
      display_name_en: 'Lancet',
      value: '786e419c-333c-4f78-858d-e00ae8825d26',
    },
    {
      display_name_cn: 'N Engl J Med',
      display_name_en: 'N Engl J Med',
      value: 'cafa1341-670f-41a6-a532-a9109817f1a5',
    },
    {
      display_name_cn: 'Proc Natl Acad Sci U S A',
      display_name_en: 'Proc Natl Acad Sci U S A',
      value: '2f87450e-4447-43af-b10c-c903a5adbef3',
    },
    {
      display_name_cn: 'Nat Commun',
      display_name_en: 'Nat Commun',
      value: 'a52a273f-d04d-42b2-9c18-455778864b76',
    },
    {
      display_name_cn: 'Nat Genet',
      display_name_en: 'Nat Genet',
      value: '6f36bc22-4c54-4983-a46f-ac2c13632cb7',
    },

    {
      display_name_cn: 'Nat Med',
      display_name_en: 'Nat Med',
      value: 'dec8f629-42b4-43ed-8f5f-015f875eaa64',
    },
    {
      display_name_cn: 'Sci Transl Med',
      display_name_en: 'Sci Transl Med',
      value: 'ea68fe7b-5030-4ab7-b13c-f6246ad68e3e',
    },
    {
      display_name_cn: 'J Med Chem',
      display_name_en: 'J Med Chem',
      value: 'c76133d1-b056-4907-9edc-930de76e679d',
    },
  ],
  milestoneItems: [
    {
      display_name_en: 'All',
      value: 'All',
      display_name_cn: 'All',
    },
    {
      display_name_cn: '首次申请临床',
      display_name_en: 'First IND Application',
      value: 'FIRST_IND_APPLICATION_DATE',
    },
    {
      display_name_cn: '首次1期临床',
      display_name_en: 'First Phase 1 Clinical',
      value: 'FIRST_PHASE1_DATE',
    },
    {
      display_name_cn: '首次2期临床',
      display_name_en: 'First Phase 2 Clinical',
      value: 'FIRST_PHASE2_DATE',
    },
    {
      display_name_cn: '首次3期临床',
      display_name_en: 'First Phase 3 Clinical',
      value: 'FIRST_PHASE3_DATE',
    },
    {
      display_name_cn: '首次申请上市',
      display_name_en: 'First NDA/BLA',
      value: 'FIRST_NDA_BLA_DATE',
    },
    {
      display_name_cn: '首次批准上市',
      display_name_en: 'First Approved',
      value: 'FIRST_NDA_APPROVAL_DATE',
    },
  ],
  geneticMaterialItems: [
    {
      display_name_en: 'All',
      value: 'All',
      display_name_cn: 'All',
    },
    {
      display_name_cn: 'cirRNA',
      display_name_en: 'cirRNA',
      value: 'f8894c8c9e424a27a25ebcd8ad178b38',
    },
    {
      display_name_cn: 'dsRNA',
      display_name_en: 'dsRNA',
      value: 'ee8e7b3f7e4e4063807592ff2cacb2f1',
    },

    {
      display_name_cn: 'ssRNA',
      display_name_en: 'ssRNA',
      value: '80b321066a6141e9939dab08554a3301',
    },
    {
      display_name_cn: 'ssPMO',
      display_name_en: 'ssPMO',
      value: '4a048804e4d44551a9d2ec99007696e9',
    },
    {
      display_name_cn: 'DNA gap-RNA flank',
      display_name_en: 'DNA gap-RNA flank',
      value: '98d361a2fe78458182e3b68f30d261d5',
    },
    {
      display_name_cn: 'ssDNA',
      display_name_en: 'ssDNA',
      value: '4da1e22a311e417a9906371a9a5eb744',
    },
  ],
  orgRoleItems: [
    { value: 'All', display_name_en: 'All', display_name_cn: 'All' },
    { value: 'Active', display_name_en: 'Active', display_name_cn: '在研机构' },
    { value: 'Inactive', display_name_en: 'Inactive', display_name_cn: '非在研机构' },
    { value: 'Originator', display_name_en: 'Originator', display_name_cn: '原研机构' },
    { value: 'EquityInstitutions', display_name_en: 'License', display_name_cn: '权益机构' },
  ],
  indicationPhaseItems: [
    { value: 'All', display_name_en: 'All', display_name_cn: 'All' },
    { value: 'Active', display_name_en: 'Active', display_name_cn: '在研' },
    { value: 'Inactive', display_name_en: 'Inactive', display_name_cn: '非在研' },
  ],
}

/**
 * 自定义时间的tags配置项
 */
export const CustomDateRageConfig: Record<
  ICustomDateKey,
  { val: number; unit: string; name_en: string; name_cn: string; calcType: 'before' | 'after' }[]
> = {
  dateRangeItems: [
    {
      val: 1,
      unit: 'w',
      name_en: 'Within 1 week',
      name_cn: '1周内',
      calcType: 'before',
    },
    {
      val: 1,
      unit: 'M',
      name_en: 'Within 1 Month',
      name_cn: '1个月内',
      calcType: 'before',
    },
    {
      val: 3,
      unit: 'M',
      name_en: 'Within 3 Months',
      name_cn: '3个月内',
      calcType: 'before',
    },
    {
      val: 1,
      unit: 'y',
      name_en: 'Within 1 Year',
      name_cn: '1年内',
      calcType: 'before',
    },
  ],
  applicationDateItems: [
    {
      val: 3,
      unit: 'M',
      name_en: 'Within 3 Months',
      name_cn: '3个月内',
      calcType: 'before',
    },
    {
      val: 6,
      unit: 'M',
      name_en: 'Within 6 Months',
      name_cn: '6个月内',
      calcType: 'before',
    },
    {
      val: 1,
      unit: 'y',
      name_en: 'Within 1 Year',
      name_cn: '1年内',
      calcType: 'before',
    },
  ],
  publicationDateItems: [
    {
      val: 1,
      unit: 'M',
      name_en: 'Within 1 Month',
      name_cn: '1个月内',
      calcType: 'before',
    },
    {
      val: 3,
      unit: 'M',
      name_en: 'Within 3 Months',
      name_cn: '3个月内',
      calcType: 'before',
    },
    {
      val: 6,
      unit: 'M',
      name_en: 'Within 6 Months',
      name_cn: '6个月内',
      calcType: 'before',
    },
    {
      val: 1,
      unit: 'y',
      name_en: 'Within 1 Year',
      name_cn: '1年内',
      calcType: 'before',
    },
  ],
  estimatedExpiryDateItems: [
    {
      val: 1,
      unit: 'y',
      name_en: 'Within 1 Year',
      name_cn: '1年内',
      calcType: 'after',
    },
    {
      val: 3,
      unit: 'y',
      name_en: 'Within 3 Years',
      name_cn: '3年内',
      calcType: 'after',
    },
    {
      val: 5,
      unit: 'y',
      name_en: 'Within 5 Years',
      name_cn: '5年内',
      calcType: 'after',
    },
  ],
  /** 文献申请年：query使用整年，所以val比年数少1 */
  publicationYearItems: [
    {
      val: 0,
      unit: 'y',
      name_en: 'Within 1 Year',
      name_cn: '1年内',
      calcType: 'before',
    },
    {
      val: 2,
      unit: 'y',
      name_en: 'Within 3 Years',
      name_cn: '3年内',
      calcType: 'before',
    },
    {
      val: 4,
      unit: 'y',
      name_en: 'Within 5 Years',
      name_cn: '5年内',
      calcType: 'before',
    },
  ],
  drugDealDateItems: [
    {
      val: 1,
      unit: 'y',
      name_en: 'Within 1 Year',
      name_cn: '1年内',
      calcType: 'before',
    },
    {
      val: 3,
      unit: 'y',
      name_en: 'Within 3 Years',
      name_cn: '3年内',
      calcType: 'before',
    },
    {
      val: 5,
      unit: 'y',
      name_en: 'Within 5 Years',
      name_cn: '5年内',
      calcType: 'before',
    },
  ],
  transMedicinePublicationDateItems: [
    {
      val: 1,
      unit: 'w',
      name_en: 'Within 1 week',
      name_cn: '1周内',
      calcType: 'before',
    },
    {
      val: 1,
      unit: 'M',
      name_en: 'Within 1 Month',
      name_cn: '1个月内',
      calcType: 'before',
    },
    {
      val: 1,
      unit: 'y',
      name_en: 'Within 1 Year',
      name_cn: '1年内',
      calcType: 'before',
    },
    {
      val: 3,
      unit: 'y',
      name_en: 'Within 3 Years',
      name_cn: '3年内',
      calcType: 'before',
    },
  ],
}

/**
 * 自定义number的tags配置项
 */
export const CustomNumberRageConfig: Record<ICustomNumberRangeKey, { from: number; to?: number; name_en: string; name_cn: string }[]> = {
  numberRangeItems: [
    {
      from: 0,
      to: 15,
      name_en: '0~15',
      name_cn: '0~15',
    },
    {
      from: 15,
      to: 60,
      name_en: '15~60',
      name_cn: '15~60',
    },
    {
      from: 60,
      to: 300,
      name_en: '60~300',
      name_cn: '60~300',
    },
    {
      from: 300,
      to: 500,
      name_en: '300~500',
      name_cn: '300~500',
    },
    {
      from: 500,
      name_en: '≥500',
      name_cn: '≥500',
    },
  ],
  drugDealAmountItems: [
    {
      from: 0,
      to: 10,
      name_en: '< $10M',
      name_cn: '< $10M',
    },
    {
      from: 10,
      to: 50,
      name_en: '$10M ~ $50M',
      name_cn: '$10M ~ $50M',
    },
    {
      from: 50,
      to: 100,
      name_en: '$50M ~ $100M',
      name_cn: '$50M ~ $100M',
    },
    {
      from: 100,
      to: 500,
      name_en: '$100M ~ $500M',
      name_cn: '$100M ~ $500M',
    },
    {
      from: 500,
      to: 1000,
      name_en: '$500M ~ $1B',
      name_cn: '$500M ~ $1B',
    },
    {
      from: 1000,
      name_en: '> $1B',
      name_cn: '> $1B',
    },
  ],
}

export type ISimpleOrgType = 'Company' | 'Education' | 'Other'

export const orgTypeConfig: Record<ISimpleOrgType, { id: string; display_name_en: string; display_name_cn: string }> = {
  Company: {
    display_name_cn: '公司',
    display_name_en: 'Company',
    id: 'Company',
  },
  Education: {
    display_name_cn: '大学/机构',
    display_name_en: 'University/Institution',
    id: 'Education',
  },
  Other: {
    display_name_cn: '其他',
    display_name_en: 'Other',
    id: 'Other',
  },
}

export const disableViewDetailAutocompleteTypeList: IAutoCompleteType[] = ['Topic']
